import HeaderNavSimplified from './HeaderNavSimplified';

export default HeaderNavSimplified;
